import { useRef, useState, useEffect } from "react";
import {
  useLocation,
  useNavigate,
  useSearchParams,
  Link,
} from "react-router-dom";
import { useDispatch } from "react-redux";
import { setCredentials } from "./authSlice";
import { useLoginMutation } from "./authApiSlice";
import { useGoogleSignInMutation } from "./ForgotApiSlice";
import useTitle from "../../hooks/useTitle";
import PulseLoader from "react-spinners/PulseLoader";
import { FaEye, FaEyeSlash, FaUserAlt } from "react-icons/fa";
import { IoLockClosedOutline } from "react-icons/io5";
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import ReCAPTCHA from "react-google-recaptcha";
import useAuth from "../../hooks/useAuth";
import jwtDecode from "jwt-decode";

const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
console.log("hello sitekey", siteKey);

const Login = () => {
  useTitle("Vizta");
  const [searchParams] = useSearchParams();
  const incomingUser = searchParams.get("user");
  const defaultPassword = searchParams.get("dp");
  console.log(defaultPassword);
  let incomingPassword = "";
  if (defaultPassword === "Y") {
    console.log("default password");
    incomingPassword = "123456";
  }
  console.log(incomingPassword);

  const [showPassword, setShowPassword] = useState(false);
  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const errRef = useRef();
  const location = useLocation();
  console.log(location.state?.from.pathname);
  const from = location.state?.from
    ? `${location.state.from.pathname}${location.state.from.search}`
    : "/home/dash";

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [username, setUsername] = useState();
  const [password, setPassword] = useState();
  const [responseContent, setResponseContent] = useState("");
  const [login, { data, isLoading, isError, isSuccess, error }] =
    useLoginMutation();
  console.log("logindata", data);

  // localStorage.setItem(
  //   "userDetails",
  //   JSON.stringify({ name: data.name, email: data.email })
  // );

  const [
    googleSignIn,
    {
      isLoading: googleLoading,
      isSuccess: googleLoadingSuccess,
      error: googleError,
    },
  ] = useGoogleSignInMutation();

  const handleUserInput = (e) => setUsername(e.target.value);
  const handlePwdInput = (e) => setPassword(e.target.value);
  const { roles } = useAuth();

  if (roles.length > 0) {
    navigate(from, { replace: true });
  }

  useEffect(() => {
    setResponseContent(null);
  }, [username, password]);

  useEffect(() => {
    setPassword(incomingPassword);
    setUsername(incomingUser);
  }, []);

  const [captchaVerified, setCaptchaVerified] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  // Handle reCAPTCHA verification
  const handleCaptchaChange = (token) => {
    if (token) {
      // console.log("Captcha Verified:", token);
      setCaptchaVerified(true);
      setErrorMessage("");
    } else {
      setCaptchaVerified(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // ✅ If reCAPTCHA is not verified, do not submit
    if (!captchaVerified) {
      setErrorMessage("Please complete the reCAPTCHA first.");
      return;
    }
    try {
      const userData = await login({
        user: username,
        pwd: password,
      }).unwrap();

      const { accessToken, userCompanylogo, name, email } = userData;
      dispatch(setCredentials({ accessToken }));
      const accessTokenData = { accessToken };
      localStorage.setItem("accessTokenData", JSON.stringify(accessTokenData));
      const userCompanyDetails = { userCompanylogo, name, email };
      localStorage.setItem(
        "userCompanyDetails",
        JSON.stringify(userCompanyDetails)
      );
      navigate(from, { replace: true });
    } catch (err) {
      console.error("Failed to login", err);
      setResponseContent(
        <div
          className={`text-red-600 text-xl font-medium w-[95%] text-center bg-red-200 border border-red-600 rounded-lg flex items-center justify-center py-[0.8rem]`}
        >
          Login failed. Please try again.
        </div>
      );
    }
  };

  useEffect(() => {
    if (isError) {
      setResponseContent(
        <div
          className={`text-red-600 text-xl font-medium w-[95%] text-center bg-red-200 border border-red-600 rounded-lg flex items-center justify-center py-[0.8rem]`}
        >
          {error.data}
        </div>
      );
    } else if (isSuccess) {
      const { accessToken } = data;
      dispatch(setCredentials({ accessToken }));
      navigate("/login"); // Navigate to dashboard on success
    } else {
      setResponseContent(null);
    }
  }, [isError, error, isSuccess, data, dispatch, navigate]);

  const handleGoogleLoginSuccess = async (credentialResponse) => {
    console.log(credentialResponse);
    try {
      // Call the mutation for Google sign-in
      const response = await googleSignIn({
        token: credentialResponse.credential, // Pass the token to your API
      }).unwrap();

      // Handle successful login
      if (response && response.accessToken) {
        dispatch(setCredentials({ accessToken: response.accessToken }));
        localStorage.setItem("accessToken", response.accessToken);
        navigate("/home/dash");
      } else {
        console.log("login failed");
      }
    } catch (error) {
      console.error("Login failed:", error);
      if (error?.status === 404) {
        try {
          const decodedJwt = jwtDecode(credentialResponse.credential);
          const { email: decodedEmail, name: decodedName } = decodedJwt;
          const userCompanyDetails = { name: decodedName, email: decodedEmail };
          localStorage.setItem(
            "userCompanyDetails",
            JSON.stringify(userCompanyDetails)
          );
        } catch (error) {
          console.log("error while decoding the jwt response", error.message);
        }

        navigate("/register");
      }
    }
  };

  const handleFailure = (error) => {
    console.error("Google Login Failed:", error);
    // Check if it's a 404 error and redirect to register page
    if (error?.status === 404) {
      navigate("/register");
    }
  };

  // if (isLoading) return <PulseLoader color={"#FFF"} />;

  return (
    <div className="flex flex-col items-center justify-center min-h-screen py-4 bg-gray-100">
      <main className="w-full max-w-4xl flex flex-col lg:flex-row bg-white shadow-md rounded-lg overflow-hidden">
        {/* left-side */}
        <section className="flex flex-col justify-evenly items-center lg:w-1/2 p-4">
          {responseContent ? (
            responseContent
          ) : (
            <img src="/assets/viz.png" alt="" className="w-1/2 mb-4" />
          )}
          <form
            onSubmit={handleSubmit}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                handleSubmit(e);
              }
            }}
            className="w-full flex flex-col gap-4 items-center"
          >
            <div className="text-2xl font-medium text-blue-950 w-full text-center mb-2">
              <h1>Login</h1>
              <p className="text-lg font-normal">Please login to continue</p>
            </div>

            <div className="w-full flex flex-col gap-4">
              <div className="relative w-full">
                <FaUserAlt className="absolute top-1/2 left-3 transform -translate-y-1/2 text-gray-500" />
                <input
                  onChange={handleUserInput}
                  value={username}
                  name="user"
                  className="text-lg rounded border border-gray-300 px-10 py-2 w-full"
                  type="text"
                  placeholder="enter your username"
                />
              </div>

              <div className="relative w-full">
                <IoLockClosedOutline className="absolute top-1/2 left-3 transform -translate-y-1/2 text-gray-500" />
                <input
                  type={showPassword ? "text" : "password"}
                  onChange={handlePwdInput}
                  value={password}
                  name="pwd"
                  className="text-lg rounded border border-gray-300 px-10 py-2 w-full"
                  placeholder="enter your password"
                />
                <span
                  className="absolute top-1/2 right-3 transform -translate-y-1/2 cursor-pointer"
                  onClick={handleTogglePasswordVisibility}
                >
                  {showPassword ? (
                    <FaEyeSlash fill="#4e4e52" />
                  ) : (
                    <FaEye fill="#4e4e52" />
                  )}
                </span>
              </div>

              <div className="w-[20%] flex flex-col gap-1 ml-20 rounded">
                <div className="scale-[0.8] rounded-md">
                  <ReCAPTCHA sitekey={siteKey} onChange={handleCaptchaChange} />
                </div>
              </div>

              <button
                className={`w-full text-white py-2 rounded text-lg font-medium mt-4 transition-all duration-300 ${
                  captchaVerified ? "bg-blue-950" : "bg-gray-300"
                }`}
                type="submit"
                disabled={!captchaVerified || isLoading}
              >
                LOGIN
              </button>
              <div className="flex justify-center items-center w-full mt-2 font-medium  text-[0.7rem]">
                <Link to="/forget" className="text-blue-600 hover:underline ">
                  FORGOT PASSWORD
                </Link>
                <span className="mx-2 text-gray-400 font-bold">|</span>
                <Link to="/register" className="text-blue-600 hover:underline">
                  CREATE AN ACCOUNT
                </Link>
              </div>
              <GoogleOAuthProvider clientId="307716812746-kgmptp29q2lgmrq37eug12fcni446ib6.apps.googleusercontent.com">
                <div className="w-full  text-white py-2 rounded text-lg font-bold mt-1 flex items-center justify-center space-x-2">
                  {googleLoading ? (
                    // Show a loading spinner or text while the request is being processed
                    <PulseLoader color="#fff" size={10} />
                  ) : (
                    <GoogleLogin
                      onSuccess={handleGoogleLoginSuccess}
                      onFailure={handleFailure}
                    />
                  )}
                </div>

                {googleLoadingSuccess && (
                  // Display success message if Google login was successful
                  <div className="text-green-600 text-xl font-semibold w-full text-center mt-2">
                    Login successful! Redirecting...
                  </div>
                )}

                {googleError && (
                  // Display error message if Google login failed
                  <div className="text-red-600 text-xl font-semibold w-full text-center mt-2">
                    Google login failed. Please try again.
                  </div>
                )}
              </GoogleOAuthProvider>

              <p className="text-center mt-4 text-sm">
                By logging in, you agree to our{" "}
                <span className="text-blue-600">Terms of Service</span> and{" "}
                <span className="text-blue-600">Privacy Policy</span>
              </p>
            </div>
          </form>
        </section>

        {/* right-side */}
        <section className="lg:w-1/2 flex flex-col items-center justify-center bg-gray-200 p-4">
          <h2 className="text-2xl lg:text-3xl text-center mb-4">
            Data Visualized, Decisions Amplified
          </h2>
          <img
            src="/assets/Data-report.png"
            alt="dataReport"
            className="w-3/4 mb-4"
          />
          <p className="text-lg font-medium text-center">
            Decision thrive when rooted in data. Harness the power of insights
            to drive informed choices and unlock unparalleled success.
          </p>
        </section>
      </main>
    </div>
  );
};

export default Login;
